export const FIRM_DOCUMENT_MEASUREMENT_DATES_QUERY_KEY = 'firmDocumentMeasurementDates';
export const FIRM_DOCUMENT_MEASUREMENT_DATES_QUERY_PAGE_SIZE = 10;
export const FIRM_DOCUMENT_MEASUREMENT_DATES_QUERY_STALE_TIME_MS = 1000 * 60;
